import { isEmpty } from "@swiggy-private/js-utils";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

export const isUserLoggedIn = (
    swiggyHeaders: GetSwiggyHeadersResponsePayload | undefined
): boolean => {
    return (
        !isEmpty(swiggyHeaders?.tid) &&
        !isEmpty(swiggyHeaders?.userId) &&
        !isEmpty(swiggyHeaders?.token)
    );
};
